import { Button, TextInput, Spacing, FormField } from 'zens-storybook'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { object, string } from 'yup'
import { useRouter, useNumberParams, useParams } from 'zens-router'
import { AuthPanel } from '@dms/component'
import { ValidationError } from '@dms/helper'

const styles = StyleSheet.create({
  input: {
    marginTop: Spacing.M,
    marginBottom: Spacing.XS,
    minHeight: 92,
  },
  button: {
    minWidth: 100,
  },
})

const AuthEmail = () => {
  const [{ companyId }] = useNumberParams()
  const [{ email: emailParam }] = useParams()
  const [email, setEmail] = useState(emailParam || '')
  const [errors, setErrors] = useState<Record<string, string>>({})
  const router = useRouter()
  const { t } = useTranslation()

  useEffect(() => {
    setErrors({})
  }, [email])

  const goNext = () => {
    try {
      const schema = object({
        email: string().required(t('Email address is required')).email(t('Invalid email address')),
      })
      schema.validateSync({ email, remember: false })
    } catch (error) {
      const { message, path } = error as ValidationError
      setErrors({ [path]: message })
      return
    }
    router.push({ pathname: `/signin`, params: { email, companyId } })
  }

  return (
    <AuthPanel
      title={t('Sign in')}
      bottom={<Button title={t('Next')} style={styles.button} onPress={goNext} testID="AuthEmail.Submit" />}
    >
      <FormField label={t('Email')} error={errors.email} style={styles.input}>
        <TextInput
          placeholder={t('Enter your email here')}
          value={email}
          onChangeText={setEmail}
          onSubmitEditing={goNext}
          inputMode="email"
          autoCapitalize="none"
          autoComplete="email"
          error={!!errors.email}
          autoFocus
          testID="AuthEmail.Email"
        />
      </FormField>
      {/* <Hyperlink title={t('Having trouble signing in?')} /> */}
    </AuthPanel>
  )
}

export default AuthEmail
